import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import MenuLayout from "./layout/Menu.jsx";
import Home from "./views/Home.jsx";

import InventarioView from "./views/InventarioView";
import InventarioForm from "./components/InventarioForm";

import ContratosView from "./views/ContratosView";
import ContratoForm from "./components/ContratoForm";

import LoaderGate from "./utils/LoaderGate";
import AuthGate from "./auth/AuthGate";
import Callback from "./auth/Callback";
import Logout from "./auth/Logout";

import IncidenciasCrear from "./views/incidencias/IncidenciasCrear";
import IncidenciasListado from "./views/incidencias/IncidenciasListado";

import Configuracion from "./views/Configuracion";  // ⚙️ <-- ya estaba ok

import Dashboard from "./views/Dashboard.jsx";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ⚠️ Callback y Logout VAN FUERA de AuthGate */}
        <Route path="/callback" element={<Callback />} />
        <Route path="/logout" element={<Logout />} />

        {/* 🔐 TODAS LAS RUTAS PROTEGIDAS */}
        <Route
          path="*"
          element={
            <AuthGate>
              <LoaderGate>
                <MenuLayout>
                  <Routes>

                    <Route path="/" element={<Home />} />
                    <Route path="/dashboard" element={<Dashboard />} />

                    <Route path="/inventario" element={<InventarioView />} />
                    <Route path="/agregar" element={<InventarioForm />} />

                    <Route path="/contratos" element={<ContratosView />} />
                    <Route path="/contratos/agregar" element={<ContratoForm />} />
                    <Route path="/contratos/editar/:id" element={<ContratoForm />} />

                    <Route path="/incidencias" element={<IncidenciasListado />} />
                    <Route path="/incidencias/crear" element={<IncidenciasCrear />} />

                    {/* ⚙️ NUEVA RUTA: CONFIGURACIÓN */}
                    <Route path="/configuracion" element={<Configuracion />} />

                    {/* DEFAULT */}
                    <Route path="*" element={<Home />} />

                  </Routes>
                </MenuLayout>
              </LoaderGate>
            </AuthGate>
          }
        />

      </Routes>
    </BrowserRouter>
  );
}
